import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/base.css'
import './styles/public.css'

const launchUrl = new URL(window.location.href)
if (launchUrl.searchParams.has('_app_refresh')) {
  launchUrl.searchParams.delete('_app_refresh')
  window.history.replaceState(window.history.state, '', `${launchUrl.pathname}${launchUrl.search}${launchUrl.hash}`)
}

const rootElement = document.getElementById('root')
const application = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)

if (rootElement.hasChildNodes() && window.location.pathname === '/') {
  hydrateRoot(rootElement, application)
} else {
  rootElement.replaceChildren()
  createRoot(rootElement).render(application)
  requestAnimationFrame(() => document.documentElement.classList.remove('app-route'))
}

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((error) => {
        console.error('Unable to register the offline app service worker.', error)
      })
    })
  } else {
    // A service worker installed by a previous local production preview can
    // otherwise keep serving stale hashed route chunks during development.
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .then(() => caches.keys())
      .then((keys) => Promise.all(keys.filter((key) => key.startsWith('blazin-app-')).map((key) => caches.delete(key))))
      .catch((error) => console.warn('Unable to clear the local preview cache.', error))
  }
}
